import React from "react";
import {Navbar, NavDropdown, Container} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import {logout} from "../services/authenticate";

const NavBar = () => {
    const location = useLocation();

    const handleLogout = () => {
        logout();
    };

    return (
        <Navbar bg="light" expand="lg" style={{backgroundColor: "darkgray"}}>
            <Container fluid style={{maxWidth: "100%", padding: "0 20px"}}>
                <Navbar.Brand>
                    <Link to="/">
                        <img
                            src="/jingus-logo1.png"
                            alt="Logo"
                            style={{
                                width: "80px", // Increased width
                                height: "80px", // Increased height
                                marginRight: "20px",
                            }}
                        />
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                {location.pathname !== "/" && (
                    <Navbar.Collapse className="justify-content-end">
                        <div className="d-flex align-items-center">
                            <NavDropdown
                                title="Tool"
                                id="basic-nav-dropdown"
                                style={{color: "black", marginRight: "30px"}}
                                align="end"
                            >
                                <NavDropdown.Item
                                    as={Link}
                                    to="/stockSearch"
                                    style={{color: "black"}}
                                >
                                    stockSearch
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/search"
                                    style={{color: "black"}}
                                >
                                    IsbnSearch
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/order"
                                    style={{color: "black"}}
                                >
                                    Order
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/transaction"
                                    style={{color: "black"}}
                                >
                                    Transaction
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/instagramPost" style={{color: "black"}}>
                                    Instagram Post
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/theme" style={{color: "black"}}>
                                    Theme Prompt
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/profile"
                                    style={{color: "black"}}
                                >
                                    UserProfile
                                </NavDropdown.Item>
                            </NavDropdown>
                            <button
                                onClick={handleLogout}
                                style={{
                                    marginLeft: "20px",
                                    textDecoration: "none",
                                    border: "none",
                                }}
                            >
                                LogOut
                            </button>
                        </div>
                    </Navbar.Collapse>
                )}
            </Container>
        </Navbar>
    );
};

export default NavBar;
